import gql from "graphql-tag";

export const ALL_TITULAIRES_QUERY = gql`
  query titulaireList {
    allTitulaires(orderBy: NOM_ASC) {
      edges {
        node {
          id
          adeli
          sel
          numsel
          rpps
          retraite
          ordre
          nom
          prenom
          fullName
          createdAt
          updatedAt
          photo
          photoFileName
          photoFileSize
          photoContentType
          photoUpdatedAt
        }
      }
    }
  }
`;

export const ACTIFS_TITULAIRES_QUERY = gql`
  query titulaireList {
    allTitulaires(orderBy: NOM_ASC, condition: { retraite: false }) {
      edges {
        node {
          id
          adeli
          sel
          numsel
          rpps
          retraite
          ordre
          nom
          prenom
          fullName
          createdAt
          updatedAt
          photo
          photoFileName
          photoFileSize
          photoContentType
          photoUpdatedAt
        }
      }
    }
  }
`;

export const DELETE_TITULAIRE = gql`
  mutation($id: Int!) {
    deleteTitulaireById(input: { id: $id }) {
      deletedTitulaireId
      titulaire {
        nom
      }
    }
  }
`;

export const ALL_REMPLACANTS_QUERY = gql`
  query remplacantsList {
    allRemplacants(orderBy: NOM_ASC) {
      edges {
        node {
          id
          ordre
          nom
          prenom
          urssaf
          adresse
          typeContrat
          createdAt
          actif
        }
      }
    }
  }
`;

export const ACTIFS_REMPLACANTS_QUERY = gql`
  query remplacantsList {
    allRemplacants(orderBy: NOM_ASC, condition: { actif: true }) {
      edges {
        node {
          id
          ordre
          nom
          prenom
          urssaf
          adresse
          typeContrat
          createdAt
          actif
        }
      }
    }
  }
`;

export const DELETE_REMPLACANT = gql`
  mutation($id: Int!) {
    deleteRemplacantById(input: { id: $id }) {
      deletedRemplacantId
      remplacant {
        nom
      }
    }
  }
`;

export const ALL_CONTRATS_QUERY = gql`
  query contratsList($first: Int!, $offset: Int!) {
    allContrats(first: $first, offset: $offset, orderBy: ID_DESC) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
      edges {
        node {
          id
          titulaireId
          remplacantId
          createdAt
          updatedAt
          dates
          date1
          date2
          date3
          date4
          date5
          date6
          setDatesFields
          getCountDays
          titulaireByTitulaireId {
            id
            nom
            prenom
            sel
            numsel
            ordre
            fullName
            rpps
          }
          remplacantByRemplacantId {
            id
            nom
            prenom
            typeContrat
            urssaf
            adresse
            ordre
            salutation
            fullName
            email
            lieuNaiss
            dateNaiss
            telephone
            autreAssurance
          }
        }
      }
    }
  }
`;

export const DELETE_CONTRAT = gql`
  mutation($id: Int!) {
    deleteContratById(input: { id: $id }) {
      deletedContratId
      contrat {
        id
      }
    }
  }
`;

export const CREATE_CONTRAT = gql`
  mutation(
    $titulaireId: Int!
    $remplacantId: Int!
    $date1: Date
    $date2: Date
    $date3: Date
    $date4: Date
    $date5: Date
    $date6: Date
  ) {
    createContrat(
      input: {
        contrat: {
          titulaireId: $titulaireId
          remplacantId: $remplacantId
          date1: $date1
          date2: $date2
          date3: $date3
          date4: $date4
          date5: $date5
          date6: $date6
        }
      }
    ) {
      contratEdge {
        node {
          id
          setDatesFields
        }
      }
    }
  }
`;

export const UPDATE_CONTRAT = gql`
  mutation(
    $id: Int!
    $date1: Date
    $date2: Date
    $date3: Date
    $date4: Date
    $date5: Date
    $date6: Date
  ) {
    updateContratById(
      input: {
        id: $id
        contratPatch: {
          date1: $date1
          date2: $date2
          date3: $date3
          date4: $date4
          date5: $date5
          date6: $date6
        }
      }
    ) {
      contrat {
        titulaireId
        remplacantId
        date1
        date2
        date3
        date4
        date5
        date6
        setDatesFields
      }
    }
  }
`;

export const CONTRAT_BY_ID_QUERY = gql`
  query contratById($id: Int!) {
    contratById(id: $id) {
      id
      createdAt
      titulaireId
      remplacantId
      remplacantByRemplacantId {
        id
        nom
        prenom
        typeContrat
        urssaf
        adresse
        ordre
        salutation
        fullName
        email
        lieuNaiss
        dateNaiss
        telephone
        autreAssurance
      }
      titulaireByTitulaireId {
        id
        nom
        prenom
        sel
        ordre
        numsel
        fullName
        rpps
      }
      date1
      date2
      date3
      date4
      date5
      date6
      setDatesFields
      getCountDays
    }
  }
`;

export const CREATE_TITULAIRE = gql`
  mutation create_titulaire(
    $nom: String!
    $prenom: String
    $sel: String
    $numsel: String
    $adeli: String
    $ordre: String
    $rpps: String
    $retraite: Boolean
  ) {
    createTitulaire(
      input: {
        titulaire: {
          nom: $nom
          prenom: $prenom
          sel: $sel
          numsel: $numsel
          adeli: $adeli
          ordre: $ordre
          rpps: $rpps
          retraite: $retraite
        }
      }
    ) {
      titulaireEdge {
        node {
          id
          nom
          prenom
          sel
          numsel
          adeli
          ordre
          rpps
          retraite
        }
      }
    }
  }
`;

export const UPDATE_TITULAIRE = gql`
  mutation(
    $id: Int!
    $nom: String
    $prenom: String
    $sel: String
    $numsel: String
    $adeli: String
    $ordre: String
    $rpps: String
    $retraite: Boolean
  ) {
    updateTitulaireById(
      input: {
        id: $id
        titulairePatch: {
          nom: $nom
          prenom: $prenom
          sel: $sel
          numsel: $numsel
          adeli: $adeli
          ordre: $ordre
          rpps: $rpps
          retraite: $retraite
        }
      }
    ) {
      titulaire {
        id
        nom
        prenom
        sel
        numsel
        adeli
        ordre
        rpps
        retraite
      }
    }
  }
`;

export const TITULAIRE_BY_ID_QUERY = gql`
  query titulaireById($id: Int!) {
    titulaireById(id: $id) {
      nom
      prenom
      id
      sel
      numsel
      adeli
      rpps
      ordre
      retraite
      photo
      photoFileName
      photoFileSize
      photoContentType
      photoUpdatedAt
    }
  }
`;

export const REMPLACANT_BY_ID_QUERY = gql`
  query remplacantById($id: Int!) {
    remplacantById(id: $id) {
      nom
      prenom
      id
      ordre
      telephone
      email
      adresse
      salutation
      typeContrat
      urssaf
      autreAssurance
      dateNaiss
      lieuNaiss
      actif
    }
  }
`;

export const CREATE_REMPLACANT = gql`
  mutation(
    $nom: String!
    $prenom: String
    $urssaf: String
    $adresse: String
    $typeContrat: String
    $telephone: String
    $email: String
    $salutation: String
    $dateNaiss: Date
    $lieuNaiss: String
    $autreAssurance: Boolean
    $ordre: String
    $actif: Boolean
  ) {
    createRemplacant(
      input: {
        remplacant: {
          nom: $nom
          prenom: $prenom
          urssaf: $urssaf
          adresse: $adresse
          ordre: $ordre
          typeContrat: $typeContrat
          telephone: $telephone
          email: $email
          salutation: $salutation
          dateNaiss: $dateNaiss
          lieuNaiss: $lieuNaiss
          autreAssurance: $autreAssurance
          actif: $actif
        }
      }
    ) {
      remplacantEdge {
        node {
          id
          nom
          urssaf
          adresse
          ordre
          typeContrat
          telephone
          email
          salutation
          dateNaiss
          lieuNaiss
          autreAssurance
          actif
        }
      }
    }
  }
`;

export const UPDATE_REMPLACANT = gql`
  mutation(
    $id: Int!
    $nom: String
    $prenom: String
    $salutation: String
    $ordre: String
    $email: String
    $adresse: String
    $urssaf: String
    $typeContrat: String
    $telephone: String
    $dateNaiss: Date
    $lieuNaiss: String
    $autreAssurance: Boolean
    $actif: Boolean
  ) {
    updateRemplacantById(
      input: {
        id: $id
        remplacantPatch: {
          nom: $nom
          prenom: $prenom
          adresse: $adresse
          email: $email
          ordre: $ordre
          urssaf: $urssaf
          typeContrat: $typeContrat
          telephone: $telephone
          salutation: $salutation
          dateNaiss: $dateNaiss
          lieuNaiss: $lieuNaiss
          autreAssurance: $autreAssurance
          actif: $actif
        }
      }
    ) {
      remplacant {
        id
        nom
        prenom
        adresse
        email
        ordre
        urssaf
        typeContrat
        telephone
        salutation
        dateNaiss
        lieuNaiss
        autreAssurance
        actif
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/constants/graphql.js